import * as React from "react";
export class ScoreboardHeaderCell extends React.PureComponent {
    render() {
        return (React.createElement("th", { className: `rj-aggregate-scoreboard-cell ${this.props.columnClass}`, onClick: this.props.onClick },
            React.createElement("span", { className: this.props.contentClass }),
            this.props.children));
    }
}
//# sourceMappingURL=ScoreboardHeaderCell.js.map